import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import * as React from 'react';
import { ESCAPE, Subscriber, getGlobalBehaviors } from '@cian/global-behaviors';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
/**
 * Компонента для добавления подписки на Escape через @cian/global-behaviors
 *
 * Добавление подписчика происходит после монтирования компоненты
 * Удаление подписчика происходит после размонтирования компоненты
 *
 * Рендерить компоненту нужно ТОЛЬКО в случаях если что-то реально отрендерится на экране
 *
 * @export
 * @param {IEscapeProps} props
 * @returns
 */
export var Escape = /*#__PURE__*/function (_React$Component) {
  function Escape() {
    var _this;
    _classCallCheck(this, Escape);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Escape, [].concat(args));
    /**
     * По причине того, чтобы ссылка на эту функцию не менялась
     * Эту компоненту нельзя делать функциональной
     */
    _defineProperty(_this, "subscriber", new Subscriber(function () {
      if (_this.props.active) {
        _this.props.onEscape();
      }
    }));
    return _this;
  }
  _inherits(Escape, _React$Component);
  return _createClass(Escape, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      getGlobalBehaviors().subscribe(ESCAPE, this.subscriber);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      getGlobalBehaviors().unsubscribe(ESCAPE, this.subscriber);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$children;
      return /*#__PURE__*/_jsx(_Fragment, {
        children: (_this$props$children = this.props.children) !== null && _this$props$children !== void 0 ? _this$props$children : null
      });
    }
  }]);
}(React.Component);
_defineProperty(Escape, "defaultProps", {
  active: true
});